// 南一會員中心 (NaniClub) 內部服務 SSO 介接
// 串接文件：南一會員中心 內部服務 SSO API（Cookie-based SSO）
//
// 機制說明：
// 會員中心完成登入後，會將 JWT 寫入 `.nani.com.tw` 網域的 cookie
// (nani_oneclass_login_token = {"code":"SUCCESS","jwt":"{JWT}"})，
// 所有 *.nani.com.tw 子網域皆可讀取，實現單一登入。內部服務不需 client_secret。

const CLUB_SSO_DOMAIN = process.env.REACT_APP_CLUB_SSO_DOMAIN;
const CLUB_CLIENT_ID = process.env.REACT_APP_CLUB_CLIENT_ID;

// 會員中心授權端點（登入 / token 過期時的靜默重登）
export const getClubAuthUrl = () =>
  `${CLUB_SSO_DOMAIN}/oidc/auth?client_id=${encodeURIComponent(CLUB_CLIENT_ID)}`;

export const redirectToClubLogin = () => {
  window.location.href = getClubAuthUrl();
};

// 驗證 JWT（由會員中心進行完整的伺服器端驗證，無需持有任何密鑰）
// 回傳：
//   { valid: true, user, expiresAt, ... }  Token 有效
//   { valid: false }                        Token 無效 / 已過期（401）
//   { valid: false, unavailable: true }     validate 服務暫時不可用（5xx / 逾時 / 網路錯誤）
export const validateClubToken = async (token) => {
  try {
    const res = await fetch(`${CLUB_SSO_DOMAIN}/auth/validate`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (res.status === 401) return { valid: false };
    if (!res.ok) return { valid: false, unavailable: true };
    const result = await res.json();
    return { valid: result.data?.valid === true, ...(result.data || {}) };
  } catch (err) {
    return { valid: false, unavailable: true };
  }
};

// 取得會員中心完整用戶資料（Profile API）
export const getClubProfile = async (token) => {
  try {
    const res = await fetch(`${CLUB_SSO_DOMAIN}/users/profile`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return null;
    const result = await res.json();
    return result.data || null;
  } catch (err) {
    return null;
  }
};

// 清除 .nani.com.tw 網域的共用登入 cookie（僅在 *.nani.com.tw 頁面上有效）
const clearClubCookie = () => {
  document.cookie =
    "nani_oneclass_login_token=; Domain=.nani.com.tw; Path=/; Max-Age=0";
};

// 登出：通知會員中心撤銷 token → 清除 .nani.com.tw cookie → 導向第三方登出或首頁。
// SSO 專用，呼叫後頁面會導轉離開（reload 到首頁或第三方登出頁）。
// 即使會員中心登出 API 失敗，仍會清除本地憑證並回首頁，避免卡在登入狀態。
export const clubLogout = async (token) => {
  let providerLogoutUrl = null;
  try {
    const res = await fetch(`${CLUB_SSO_DOMAIN}/auth/logout`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        logoutMode: "current_device",
        reason: "user_logout",
      }),
    });
    if (res.ok) {
      const result = await res.json();
      // 若使用者透過第三方（如教育雲 MOE）登入，需再導向其登出網址
      providerLogoutUrl = result?.data?.thirdPartyLogout?.providerLogoutUrl || null;
    }
  } catch (err) {
    // 忽略錯誤，仍往下清除 cookie 並導頁
  }
  clearClubCookie();
  window.location.href = providerLogoutUrl || "/";
};
